import styled from 'styled-components';

const constants = {
  color: {
    activeSlideColor: '#BB0A30',
    black: '#000000',
    darkGrey: '#333333',
    grey: '#999999',
    lightGrey: '#F2F2F2',
    white: '#FFFFFF',
    lightBlue: 'hsla(216, 33%, 99%, 0.7)',
  },
  displaySizes: {
    mobile: '375px',
    tablet: '768px',
    smallDesktop: '1024px',
    desktop: '1440px',
    largeDesktop: '1920px',
  },
  theme: {
    darkTheme: 'darkTheme',
    lightTheme: 'lightTheme',
  },
};

interface WLTPContainerProps {
  theme: string;
}

const device = {
  desktop: `(min-width: ${constants.displaySizes.desktop})`,
  largeDesktop: `(min-width: ${constants.displaySizes.largeDesktop})`,
  mobile: `(min-width: ${constants.displaySizes.mobile})`,
  smallDesktop: `(min-width: ${constants.displaySizes.smallDesktop})`,
  tablet: `(min-width: ${constants.displaySizes.tablet})`,
  smallTablet: `(max-width: ${constants.displaySizes.tablet})`,
};

export const WLTPContainer = styled.div<WLTPContainerProps>`
  ${
    process.env.IS_LEGACY
      ? (props) => `background-color: ${props?.theme?.sys?.color?.canvas?.default}`
      : ''
  };
  padding-bottom: ${process.env.IS_LEGACY ? '24px' : '0'};

  .fg-wltp-items {
    margin: 0 5px 0 0;
  }

  p {
    color: ${
      process.env.IS_LEGACY
        ? `${constants.color.darkGrey} !important`
        : `${constants.color.lightBlue} !important`
    };
  }

  p span sup {
    font-size: 8px;
  }

  /* @media ${device.mobile} {
    p {
      color: ${(props) =>
        props.theme === constants.theme.darkTheme
          ? `${constants.color.white} !important`
          : `${constants.color.black} !important`};
    }
  } */
`;

export const MediaDisclaimerContainer = styled.div`
  width: 100%;
  p sup {
    font-size: 8px;
    font-feature-settings: normal;
    font-weight: 700;
  }

  p {
    color: ${
      process.env.IS_LEGACY
        ? `${constants.color.darkGrey} !important`
        : `${constants.color.lightBlue} !important`
    };
  }
`;
